import React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export default function PageHeader() {
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          component={Link}
          to="/catalog"
          sx={{ color: 'inherit', textDecoration: 'none' }}
        >
          Intervision
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
